import { render, staticRenderFns } from "./productInquiry.vue?vue&type=template&id=02e06dba&scoped=true"
import script from "./productInquiry.vue?vue&type=script&lang=js"
export * from "./productInquiry.vue?vue&type=script&lang=js"
import style0 from "./productInquiry.vue?vue&type=style&index=0&id=02e06dba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e06dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02e06dba')) {
      api.createRecord('02e06dba', component.options)
    } else {
      api.reload('02e06dba', component.options)
    }
    module.hot.accept("./productInquiry.vue?vue&type=template&id=02e06dba&scoped=true", function () {
      api.rerender('02e06dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inquiry/productInquiry.vue"
export default component.exports